export default __webpack_public_path__ + "static/Poppins-Light-669df14acbd3a5a2fc5a2ef124a123ed.woff2";